import "swiper/css";

import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { tickerConsts } from "../constants";

interface NewsBottomSectionProps {
  primaryColor: string;
  logo: string | null;
}

const swiperStyles = `
  .swiper-wrapper {
    transition-timing-function: linear;
  }
  .swiper-slide {
    width: auto;
  }
`;

const NewsTickerContainer = styled.div`
  width: 626px;
  height: 23px;
  overflow: hidden;
  display: flex;
`;

const StyledNewsSection = styled.div<{ primaryColor: string }>`
  font-family: var(--lato-font);
  font-size: 16px;
  font-weight: 600;
  color: var(--color-black-100, #000);
  width: auto;
  padding: 10px;
  display: flex;
  border-right: 2px solid ${(props) => props.primaryColor};
`;

const NewsItemContainer = styled.div<{ primaryColor: string }>`
  font-family: var(--lato-font);
  font-size: 16px;
  font-weight: 600;
  color: var(--color-black-100, #000);
  width: auto;
  padding-left: 5px;
  padding-right: 5px;
  border-right: 2px solid ${(props) => props.primaryColor};
`;

const CompanyLogo = styled.img`
  width: 50px;
  height: 30px;
  object-fit: contain;
`;

export function NewsBottomSection({
  primaryColor,
  logo,
}: NewsBottomSectionProps): JSX.Element {
  return (
    <StyledNewsSection primaryColor={primaryColor}>
      {logo && <CompanyLogo src={logo} alt="company logo" />}
      <NewsTickerContainer className="news-ticker-container">
        <style>{swiperStyles}</style>
        <Swiper
          navigation={false}
          className="mySwiper"
          autoplay={{ delay: 0 }}
          speed={6000}
          slidesPerView={"auto"}
          modules={[Autoplay]}
          loop={true}
          spaceBetween={0}
        >
          {tickerConsts.map((tickerConst, index) => (
            <SwiperSlide key={`ticker-${index}`}>
              <NewsItemContainer primaryColor={primaryColor}>
                {tickerConst}
              </NewsItemContainer>
            </SwiperSlide>
          ))}
        </Swiper>
      </NewsTickerContainer>
    </StyledNewsSection>
  );
}
